import { FC } from "react";

const OverpassSettings: FC = () => {
  return <>TODO</>;
};

export default OverpassSettings;
